var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "tableData",
          staticClass: "draggable-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "default-expanded-row-keys": _vm.expandedKeys,
            "header-cell-style": { background: "#f7fbff" },
            "row-key": "id",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "left", type: "", width: "25" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("i", {
                      staticClass: "sort-handle iconfont icontuodong pointer",
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.headerShow
            ? _c("el-table-column", {
                attrs: { fixed: "left", type: "selection", width: "55" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              label: "任务编号",
              "min-width": "120",
              prop: "ident",
              type: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "ident copy pointer",
                        attrs: {
                          "data-clipboard-text": _vm.identAddress(row),
                          title: "点击复制工作项地址",
                        },
                        on: { click: _vm.copy },
                      },
                      [_vm._v("#" + _vm._s(row.ident))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              label: "任务名称",
              "min-width": "320",
              prop: "name",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow
                      ? _c("span", [_vm._v("任务名称")])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.add
                      ? _c(
                          "div",
                          [
                            _c("el-input", {
                              staticStyle: { width: "260px" },
                              attrs: {
                                placeholder: "请输入版本名称(Enter保存)",
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.handleEnter(row, 0)
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleEnter(row, 1)
                                },
                              },
                              model: {
                                value: _vm.addName,
                                callback: function ($$v) {
                                  _vm.addName = $$v
                                },
                                expression: "addName",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !row.add
                      ? _c(
                          "div",
                          {
                            staticClass: "program-name",
                            on: {
                              mouseenter: function ($event) {
                                return _vm.showIcon(row.$index)
                              },
                              mouseleave: function ($event) {
                                return _vm.hideIcon(row.$index)
                              },
                            },
                          },
                          [
                            !row.edit
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: { effect: "dark", placement: "top" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pointer flex align-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.editProgram(row)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "iconfont icontask1",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "task-name line1" },
                                          [_vm._v(_vm._s(row.name))]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [_c("span", [_vm._v(_vm._s(row.name))])]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            row.edit
                              ? _c("el-input", {
                                  ref: "addInput",
                                  on: {
                                    blur: function ($event) {
                                      return _vm.putName(row, 0)
                                    },
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.putName(row, 1)
                                    },
                                  },
                                  model: {
                                    value: row.name,
                                    callback: function ($$v) {
                                      _vm.$set(row, "name", $$v)
                                    },
                                    expression: "row.name",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !row.edit
                              ? _c(
                                  "div",
                                  { staticClass: "icon-btn" },
                                  [
                                    _vm.iconVisible[row.$index] &&
                                    row.level !== 4
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              content: "新建子工作项",
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icontiaojian pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addChild(row.id)
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.iconVisible[row.$index] && row.operate
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              content: "编辑",
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "iconfont iconbianji pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editChild(row.id)
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "优先级", "min-width": "100", prop: "priority" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow ? _c("span", [_vm._v("优先级")]) : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-dropdown",
                      {
                        attrs: { placement: "bottom", trigger: "click" },
                        on: {
                          command: function ($event) {
                            return _vm.putProgramTask(
                              "priority",
                              $event,
                              row.id
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "el-dropdown-link pointer" },
                          [
                            row.priority === 1
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      size: "mini",
                                      type: "danger",
                                    },
                                  },
                                  [_vm._v("紧急")]
                                )
                              : row.priority === 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      size: "mini",
                                      type: "warning",
                                    },
                                  },
                                  [_vm._v("高")]
                                )
                              : row.priority === 3
                              ? _c(
                                  "el-tag",
                                  { attrs: { effect: "dark", size: "mini" } },
                                  [_vm._v("中")]
                                )
                              : row.priority === 4
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      size: "mini",
                                      type: "success",
                                    },
                                  },
                                  [_vm._v("低")]
                                )
                              : _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      size: "mini",
                                      type: "info",
                                    },
                                  },
                                  [_vm._v("无优先级")]
                                ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        row.operate
                          ? _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "fixed-height" },
                                  _vm._l(
                                    _vm.selectData.priorityOptions,
                                    function (item, index) {
                                      return _c(
                                        "el-dropdown-item",
                                        {
                                          key: index,
                                          attrs: { command: item.value },
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  item.value === 1
                                                    ? "danger"
                                                    : item.value === 2
                                                    ? "warning"
                                                    : item.value === 3
                                                    ? ""
                                                    : item.value === 4
                                                    ? "success"
                                                    : "info",
                                                effect: "dark",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.label))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", "min-width": "80", prop: "status" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow ? _c("span", [_vm._v("状态")]) : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-dropdown",
                      {
                        attrs: { placement: "bottom", trigger: "click" },
                        on: {
                          command: function ($event) {
                            return _vm.putProgramTask("status", $event, row.id)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "el-dropdown-link pointer" },
                          [
                            row.status === 0
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "plain",
                                      size: "mini",
                                      type: "warning",
                                    },
                                  },
                                  [_vm._v("未处理")]
                                )
                              : row.status === 1
                              ? _c(
                                  "el-tag",
                                  { attrs: { effect: "plain", size: "mini" } },
                                  [_vm._v("进行中")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            row.status === 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "plain",
                                      size: "mini",
                                      type: "info",
                                    },
                                  },
                                  [_vm._v("已解决")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            row.status === 3
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "plain",
                                      size: "mini",
                                      type: "success",
                                    },
                                  },
                                  [_vm._v("已验收")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            row.status === 4
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "plain",
                                      size: "mini",
                                      type: "danger",
                                    },
                                  },
                                  [_vm._v("已拒绝")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        row.operate
                          ? _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "fixed-height" },
                                  _vm._l(
                                    _vm.selectData.statusOptions,
                                    function (item, index) {
                                      return _c(
                                        "el-dropdown-item",
                                        {
                                          key: index,
                                          attrs: { command: item.value },
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  item.value === 4
                                                    ? "danger"
                                                    : item.value === 0
                                                    ? "warning"
                                                    : item.value === 1
                                                    ? ""
                                                    : item.value === 3
                                                    ? "success"
                                                    : "info",
                                                effect: "plain",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.label))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "负责人", "min-width": "150", prop: "admins" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow ? _c("span", [_vm._v("负责人")]) : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var index = ref.index
                  return [
                    !_vm.adminsVisible[index]
                      ? _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                return _vm.showAdmins(row, index)
                              },
                            },
                          },
                          [
                            row.admins && row.admins[0]
                              ? _c("el-avatar", {
                                  attrs: {
                                    src: row.admins[0]
                                      ? row.admins[0].avatar
                                      : "",
                                    size: "small",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            row.admins
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      row.admins[0] ? row.admins[0].name : "- -"
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "el-select",
                          {
                            attrs: { placeholder: "负责人", size: "small" },
                            on: {
                              change: function ($event) {
                                return _vm.chooseAdmins(row, row.$index)
                              },
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.changeAdmins(
                                  row.program_id,
                                  row.$index
                                )
                              },
                            },
                            model: {
                              value: _vm.adminsUid,
                              callback: function ($$v) {
                                _vm.adminsUid = $$v
                              },
                              expression: "adminsUid",
                            },
                          },
                          _vm._l(_vm.programMemberOptions, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "协作者", "min-width": "180", prop: "members" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow ? _c("span", [_vm._v("协作者")]) : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var index = ref.index
                  return [
                    !_vm.membersVisible[row.$index]
                      ? _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "pointer line1 members-line",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showMembers(row, row.$index)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          row.members
                                            .map(function (obj) {
                                              return obj.name
                                            })
                                            .join("、")
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  row.members && !row.members.length
                                    ? _c("span", [_vm._v("- -")])
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            _vm._v(" "),
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("div", { staticClass: "pointer tooltip" }, [
                                  _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          row.members
                                            .map(function (obj) {
                                              return obj.name
                                            })
                                            .join("、")
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  row.members && !row.members.length
                                    ? _c("span", [_vm._v("- -")])
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ],
                          2
                        )
                      : _c(
                          "el-select",
                          {
                            attrs: {
                              "collapse-tags": "",
                              filterable: "",
                              multiple: "",
                              placeholder: "指派协作者",
                              size: "small",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeMembers(row, index)
                              },
                            },
                            model: {
                              value: _vm.membersId,
                              callback: function ($$v) {
                                _vm.membersId = $$v
                              },
                              expression: "membersId",
                            },
                          },
                          _vm._l(_vm.programMemberOptions, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "关联项目", "min-width": "180", prop: "program" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow
                      ? _c("span", [_vm._v("关联项目")])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-dropdown",
                      {
                        attrs: { placement: "bottom", trigger: "click" },
                        on: {
                          command: function ($event) {
                            return _vm.putProgramTask(
                              "program_id",
                              $event,
                              row.id
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "pointer" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "line1 members-line" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        row.program ? row.program.name : "- -"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: { "max-width": "180px" },
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          row.program ? row.program.name : "- -"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        row.operate
                          ? _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "fixed-height" },
                                  _vm._l(
                                    _vm.projectList,
                                    function (item, index) {
                                      return _c(
                                        "el-dropdown-item",
                                        {
                                          key: index,
                                          attrs: { command: item.value },
                                        },
                                        [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(_vm._s(item.label)),
                                            ]),
                                            _vm._v(" "),
                                            item.status == 1 || item.status == 2
                                              ? _c(
                                                  "span",
                                                  {
                                                    class:
                                                      item.status == 1
                                                        ? "program-stop"
                                                        : "program-close",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.status == 1
                                                          ? "已暂停"
                                                          : "已关闭"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "关联版本", "min-width": "100", prop: "version" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow
                      ? _c("span", [_vm._v("关联版本")])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var index = ref.index
                  return [
                    _vm.showVersion === row.id
                      ? _c(
                          "el-select",
                          {
                            ref: "showVersion" + row.id,
                            attrs: {
                              placeholder: "请选择关联版本",
                              size: "small",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeParam("version_id", row)
                              },
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.changeVersion(row.program_id, index)
                              },
                            },
                            model: {
                              value: row.version.id,
                              callback: function ($$v) {
                                _vm.$set(row.version, "id", $$v)
                              },
                              expression: "row.version.id",
                            },
                          },
                          _vm._l(_vm.versionList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                return _vm.setParamId("showVersion", row.id)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "infos" }, [
                              _vm._v(
                                _vm._s(row.version ? row.version.name : "- -")
                              ),
                            ]),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "计划开始",
              "min-width": "100",
              prop: "plan_start",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow
                      ? _c("span", [_vm._v("计划开始")])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.showStartTime === row.id
                      ? _c("el-date-picker", {
                          ref: "showStartTime" + row.id,
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            clearable: "",
                            placeholder: "请选择项目计划开始日期",
                            size: "small",
                            type: "date",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.clearParamId("showStartTime")
                            },
                            change: function ($event) {
                              return _vm.putProgramTask(
                                "plan_start",
                                $event,
                                row.id
                              )
                            },
                          },
                          model: {
                            value: row.plan_start,
                            callback: function ($$v) {
                              _vm.$set(row, "plan_start", $$v)
                            },
                            expression: "row.plan_start",
                          },
                        })
                      : _c(
                          "span",
                          {
                            staticClass: "pointer width100",
                            on: {
                              click: function ($event) {
                                return _vm.setParamId("showStartTime", row.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.plan_start || "- -") +
                                "\n        "
                            ),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "计划结束",
              "min-width": "100",
              prop: "plan_end",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.showEndTime === row.id
                      ? _c("el-date-picker", {
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            clearable: "",
                            placeholder: "请选择项目计划开始日期",
                            size: "small",
                            type: "date",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.clearParamId("showEndTime")
                            },
                            change: function ($event) {
                              return _vm.putProgramTask(
                                "plan_end",
                                $event,
                                row.id
                              )
                            },
                          },
                          model: {
                            value: row.plan_end,
                            callback: function ($$v) {
                              _vm.$set(row, "plan_end", $$v)
                            },
                            expression: "row.plan_end",
                          },
                        })
                      : _c(
                          "span",
                          {
                            staticClass: "pointer width100",
                            on: {
                              click: function ($event) {
                                return _vm.setParamId("showEndTime", row.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.plan_end || "- -") +
                                "\n        "
                            ),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "创建人", "min-width": "80", prop: "creator" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow ? _c("span", [_vm._v("创建人")]) : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return _vm._l(row.creator, function (item) {
                    return _c("span", { key: item.id }, [
                      _vm._v(_vm._s(item.name)),
                    ])
                  })
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "创建时间",
              "min-width": "160",
              prop: "plan_start",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow
                      ? _c("span", [_vm._v("创建时间")])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.created_at || "- -"))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "更新时间", "min-width": "160", prop: "plan_end" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    !_vm.headerShow
                      ? _c("span", [_vm._v("更新时间")])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.updated_at || "- -"))])]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }